import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';

export class ImagingTopMenuEvent {
  static CATEGORIES = 'categories';
  static CASCADE = 'cascade';
  static TILE = 'tile';
  static OPEN_FILE = 'open-file';
  static ADD_IMAGE = 'add-image';
  static SAVE = 'save';
  static SAVE_AS_NEW = 'save-as-new';
  static SAVE_DOWNLOAD = 'save-download';
  static SAVE_CLOSE = 'save-close';
  static SAVE_ALL = 'save-all';
  static SAVE_LIB_LEC = 'save-lib-lec';
  static PRINT = 'print';
  static CAMERA = 'camera';
  static STOP_CAMERA = 'stop-folder-monitor';
  static START_CAMERA = 'start-folder-monitor';
  static STOP_CAMERA_PORTRAIT = 'stop-folder-monitor_portrait';
  static START_CAMERA_PORTRAIT = 'start-folder-monitor_portrait';
  static DESKTOP_ACQUIRE = 'desktop-acquire';
  static XRAY = 'xray';
  static SCANNER = 'scanner';
  static PORTRAIT = 'portrait';
  static CBCT = 'cbct';
  static CONFIGURE_TWAIN = 'configure-twain';

  // TODO: 5 icons after printer

  static INNER_JOIN_LEFT = 'inner-join-left';
  static COMPARE = 'compare';
  static OUTER_JOIN_RIGHT = 'outer-join-right';

  type: string;
  selectedFiles: File[];
  categories: EnumValidValueItemModel[] = [];
  folderIds: string[];
  deviceCategoryId: string;
  folderMonitorName: string;
  tileMax: number;
}
